




















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/tenant/components';

@Component
export default class WorkflowActionView extends Vue {
  public items: Common.WorkflowAction[] = new Array();
  public params: Common.WorkflowActionQuery = new Common.WorkflowActionQuery();
  public importQuery = new Common.ImportQuery('ワークフローアクション', 'WorkflowAction');
  public exportQuery = new Common.ExportQuery('ワークフローアクション', this.params);
  public sortOptions: any = [
    { value: 'workflow', text: 'ワークフロー' },
    { value: 'isTransit', text: '遷移区分' },
  ];

  public insWorkflowAction: Common.WorkflowAction = new Common.WorkflowAction();
  public addWorkflowActionFromName: string = '';
  public addWorkflowStateName: string = '';
  public addWorkflowActionToName: string = '';

  public trWorkflowStateFromId: number;
  public trWorkflowStateToId: number;
  public trWorkflowStateFrom: string = '';
  public trWorkflowStateTo: string = '';
  public trWorkflowInsActionName: string = '';

  public created(){

  }

  // ワークフロー挿入ダイアログの表示
  public showInsertWorkFlowStateDialog() {
    this.getCheckedItems();

    // ダイアログ表示前バリデーション
    if(this.checkedItems.length == 0){
      this.$api.modal.show('', '対象のアクションを選択して下さい。', true, null);
      return;
    }
    if(this.checkedItems.length > 1){
      this.$api.modal.show('', '単一のアクションを選択してください。', true, null);
      return;
    }
    if(this.checkedItems[0].isTransit){
      this.$api.modal.show('', '区間移動のアクションには挿入できません。', true, null);
      return;
    }

    const temp =  this.checkedItems[0] as Common.WorkflowAction;
    this.insWorkflowAction = this.checkedItems[0] as Common.WorkflowAction;
    this.addWorkflowActionFromName = '';
    this.addWorkflowStateName = '';
    this.addWorkflowActionToName = '';

    // ダイアログを表示
    (this.$refs.InsertWorkFlowStateDialog as Components.ListDialog).showDialog();
  }
  
  // ワークフロー連結ダイアログの表示
  public showTranslationWorkFlowStateDialog() {
    this.getCheckedItems();

    // ダイアログ表示前バリデーション
    if(this.checkedItems.length != 2){
      this.$api.modal.show('', '連結する２つのアクションを選択してください。', true, null);
      return;
    }
    let workflowId : number =this.checkedItems[0].workflowId;
    if(this.checkedItems.filter(obj => obj.workflowId != workflowId).length > 0){
      this.$api.modal.show('', 'ワークフローが共通のアクションを選択してください。', true, null);
      return;
    }
    if(this.checkedItems[0].stateIdTo != this.checkedItems[1].stateIdFrom && this.checkedItems[1].stateIdTo != this.checkedItems[0].stateIdFrom){
      this.$api.modal.show('', '連続するアクションを指定してください。', true, null);
      return;
    }

    let firstWorkflowAction : Common.WorkflowAction = this.checkedItems[0].stateIdTo == this.checkedItems[1].stateIdFrom ?  this.checkedItems[0] : this.checkedItems[1];
    let secondWorkflowAction : Common.WorkflowAction = this.checkedItems[0].stateIdTo == this.checkedItems[1].stateIdFrom ?  this.checkedItems[1] : this.checkedItems[0];

    if(firstWorkflowAction.workflow.userStates.filter(obj => obj.workflowStateId == firstWorkflowAction.stateIdTo).length < 1){
      this.$api.modal.show('', '定義済みステータスを跨ぐアクションは連結できません。', true, null);
      return;
    }

    this.trWorkflowInsActionName = '';
    this.trWorkflowStateFrom = firstWorkflowAction.workflow.getName(firstWorkflowAction.stateIdFrom);
    this.trWorkflowStateFromId = firstWorkflowAction.stateIdFrom;
    this.trWorkflowStateTo = secondWorkflowAction.workflow.getName(secondWorkflowAction.stateIdTo);
    this.trWorkflowStateToId = secondWorkflowAction.stateIdTo;

    // ダイアログを表示
    (this.$refs.RemoveWorkFlowStateDialog as Components.ListDialog).showDialog();
  }

    // 一覧でチェックされている発注明細
  public checkedItems: Array<Common.WorkflowAction>= new Array(0);
  public getCheckedItems(){
    this.checkedItems = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        this.checkedItems.push(obj);
      }
    });
  }

  public async InsertWorkFlowState()
  {
    const temp =  this.checkedItems[0] as Common.WorkflowAction;
    if(temp.workflow.controller.systemStates.filter(obj => obj.name == this.addWorkflowStateName).length+
      temp.workflow.userStates.filter(obj => obj.name == this.addWorkflowStateName).length > 0){
      this.$api.modal.show('', '既に定義されているステータス名です。異なるステータス名を指定してください。', true, null);
      (this.$refs.InsertWorkFlowStateDialog as Components.ListDialog).showDialog();
      return;
    }
    var query = new Common.InsertWorkflowActionQuery();
    query.insWorkflowAction = this.insWorkflowAction;
    query.addWorkflowActionFromName = this.addWorkflowActionFromName;
    query.addWorkflowStateName = this.addWorkflowStateName;
    query.addWorkflowActionToName = this.addWorkflowActionToName;
    // ワークフロー挿入の実行
    await this.$api.execute(query).then(res => {
      this.refreshListView();
      this.$api.perms.reloadLicense()
    });
  }

  public async TranslationWorkFlowState()
  {
    var query = new Common.TranslationWorkflowActionQuery();  
    query.trCheckedItems = this.checkedItems;
    query.trWorkflowStateFromId = this.trWorkflowStateFromId;
    query.trWorkflowStateToId = this.trWorkflowStateToId;
    query.trWorkflowInsActionName = this.trWorkflowInsActionName;
    // ワークフロー連結の実行
    await this.$api.execute(query).then(res => {
      this.refreshListView();
      this.$api.perms.reloadLicense()
    });
  }

  // 画面のリフレッシュ(再描画)
  public refreshListView(){
    var page = (this.$refs.mainList as Components.ListView).currentPage;
    (this.$refs.mainList as Components.ListView).onPageChange(page);
  }

  public async getTemplates(item: Common.WorkflowAction):Promise<Common.BindItem[]>{
      var workflowControllerName = item.workflow.controller.name;
      return this.$api.execute(new Common.WorkflowReportTemplateQuery(workflowControllerName));
  }
}

